import { Mode, ItemFilterBase } from './types';

export const textDefaultModes = ['contains', 'notcontain'] as Array<Mode>;

export const itemDefaultModes = [
  'hasany',
  'hasall',
  'is',
  'hasnone',
  'hasnothing',
  'contains',
  'notcontain',
] as Array<Mode>;

/**
 * All item filter modes, except "has none", i.e. for fields that always have a value
 */
export const itemModesMultiValuesRequired: ItemFilterBase['allowedModes'] = itemDefaultModes.reduce((accu, current) => {
  if (current === 'hasnone') {
    return accu;
  }

  accu[current] = 'multiSelect';

  return accu;
}, {});

/**
 * All item filter modes, except "has none", i.e. for fields that always have a value,
 * and except "has all", i.e. for fields that can only have a single value
 */
export const itemModesSingleValueRequired: ItemFilterBase['allowedModes'] = itemDefaultModes.reduce((accu, current) => {
  if (current === 'hasnothing' || current === 'hasall') {
    return accu;
  }

  if (current === 'is') {
    accu[current] = 'singleSelect';
  } else {
    accu[current] = 'multiSelect';
  }

  return accu;
}, {});
